module.exports = __webpack_public_path__ + "static/media/maps.60ad1f5f.png";